import setup from "app/setup/pack";
import Application from "custom/default/application";

setup({Component: Application});
